import React from 'react';
import { ConfigurationOnboarding } from './components/ConfigurationOnboarding';
import { t } from 'i18next';
import { StyleConfiguration } from './components/StyleConfiguration';
import { ConfigurationAnnualDateFee } from './components/ConfigurationAnnualDateFee';
import { PageHeadline } from '../../../components/atoms';

const EnvironmentSetupScreen: React.FunctionComponent = () => {
  return (
    <>
      <div className="mb-6">
        <PageHeadline title={t('labels.lblEnvironmentSetup')} />
      </div>

      <div className="mt-6 flex flex-col gap-6 items-start">
        <StyleConfiguration />
        <ConfigurationOnboarding />
        <ConfigurationAnnualDateFee />
      </div>
    </>
  );
};

export { EnvironmentSetupScreen };
